<script setup>
import { getMenuList } from '@/api/base'
import { setToken, setAppVersion, setAppVersionCode, setAppPackage, setAppStoreName, getAppStoreName } from '@/utils/auth'
import { initNativeBridge } from '@/utils/nativeBridge'
const DevToolsFloat =
  import.meta.env.VITE_APP_ENV !== 'production'
    ? defineAsyncComponent(() => import('@/components/DevToolsFloat/index.vue'))
    : null
const isIOSDevice = () => {
  const ua = navigator.userAgent || ''
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1)
}
const isIosUniShell = isIOSDevice() && /Html5Plus/i.test(navigator.userAgent)
// import { initPerformanceMonitor, trackEvent } from '@/utils/performance'

const isAlipayMiniProgram = () => {
  const ua = navigator.userAgent || ''
  return /AlipayClient/i.test(ua) && !/Html5Plus/i.test(ua)
}
const getUniBridge = () => {
  if (window.webUni) return window.webUni
  if (window.uni) return window.uni
  if (typeof uni !== 'undefined') return uni
  return null
}
const postAppMessage = (data) => {
  const bridge = getUniBridge()
  if (bridge?.postMessage) {
    bridge.postMessage({ data })
    return true
  }
  console.warn('App 通信桥未就绪', data)
  return false
}
const router = useRouter()
const transitionName = ref('')
const keepAliveNames = ref([])
const store = useStore()
const storeName = ref(getAppStoreName() || '')
const appChannelReady = ref(false)
let appChannelFallbackTimer = null
// 更新菜单
const menuList = async (appStoreName = storeName.value) => {
  console.log(appStoreName, 'storeName.value---')
  getMenuList({ appStoreName: appStoreName ? appStoreName.toUpperCase() : '' }).then((res) => {
    store.commit('SET_MENU_LIST', res.data)
  })
}
provide('menuList', menuList)

const getAppChannel = (data) => {
  const vp = data.split('&')
  console.log(vp[3], 'vp----')
  appChannelReady.value = true
  if (appChannelFallbackTimer) {
    clearTimeout(appChannelFallbackTimer)
    appChannelFallbackTimer = null
  }
  setAppVersion(vp[0])
  const nextStoreName = vp[3] || getAppStoreName() || ''
  storeName.value = nextStoreName
  setAppPackage(vp[1] || '')
  setAppVersionCode(vp[2] || '')
  if (nextStoreName) {
    setAppStoreName(nextStoreName)
  }
  // 获取到版本后再查询菜单
  menuList(nextStoreName)
}
const postGetAppChannelMessage = () => {
  const data = { action: 'znn_getAppChannel' }
  if (!isAlipayMiniProgram()) {
    postAppMessage(data)
    return
  }

  const postMessage = () => {
    if (window.my?.postMessage) {
      console.log('window.my.postMessage')
      window.my.postMessage({ data })
      return true
    }
    if (window.uni?.webView?.postMessage) {
      console.log('window.webView.postMessage')
      window.uni.webView.postMessage({ data })
      return true
    }
    return false
  }

  if (postMessage()) return
  document.addEventListener('UniAppJSBridgeReady', postMessage, { once: true })
  window.setTimeout(postMessage, 300)
}
const getInitialUrlParam = (name) => {
  try {
    const initialHref = window.location.href
    console.log(initialHref, 'initialHref---')
    const initialUrl = new URL(initialHref, window.location.origin)
    const searchValue = new URLSearchParams(initialUrl.search).get(name)
    if (searchValue) return searchValue

    const hashSearch = (initialUrl.hash.split('?')[1] || '').split('#')[0]
    const hashValue = new URLSearchParams(hashSearch).get(name)
    if (hashValue) return hashValue

    const hrefMatch = initialHref.match(new RegExp(`[?&]${name}=([^&#]*)`))
    return hrefMatch ? decodeURIComponent(hrefMatch[1]) : ''
  } catch (e) {
    return ''
  }
}
const getUrlAppChannel = () => getInitialUrlParam('appChannel')
const initialLoginToken = getInitialUrlParam('loginToken')
const initialLoginGoHome = getInitialUrlParam('loginGoHome') === '1'
if (initialLoginToken) {
  setToken(initialLoginToken)
  store.commit('SET_TOKEN', initialLoginToken)
}
onMounted(async () => {
  console.log(initialLoginToken, 'loginToken---')
  if (initialLoginToken) {
    oneKeyLoginResponse({
      token: initialLoginToken,
      goHome: initialLoginGoHome
    })
  }
  // debugger
  // 初始化性能监控
  // initPerformanceMonitor()
  // 获取当前版本 安卓
  window.znn_getAppChannel = getAppChannel
  const appChannel = getUrlAppChannel()
  if (appChannel) {
    getAppChannel(appChannel)
  } else {
    postGetAppChannelMessage()
  }
  appChannelFallbackTimer = window.setTimeout(() => {
    if (!appChannelReady.value) {
      menuList(getAppStoreName() || storeName.value)
    }
  }, 500)
  // todo=== 当下接口都传这个
  setAppPackage('com.huabaozx.fmall')
  // if (['development', 'staging'].includes(import.meta.env.MODE)) {
  //   setAppPackage('com.huabaozx.fmall')
  //   // 获取菜单
  //   menuList()
  // }
  // 注册一键登录获取token方法
  window.znn_oneKeyLoginResponse = oneKeyLoginResponse
  window.app_menuList = menuList
  // window.znn_goHistory = (delta = -1) => router.go(delta)
  // initNativeBridge()
})
const normalizeOneKeyLoginPayload = (payload, goHome) => {
  if (payload && typeof payload === 'object') {
    return {
      token: payload.token || payload.appToken || '',
      goHome: typeof payload.goHome === 'boolean' ? payload.goHome : goHome
    }
  }
  return { token: payload, goHome }
}

const oneKeyLoginResponse = (payload, goHome = false) => {
  const { token, goHome: needGoHome } = normalizeOneKeyLoginPayload(payload, goHome)
  if (!token) return
  setToken(token)
  store.commit('SET_TOKEN', token)
  store.dispatch('GetInfo').then(() => {
    // 更新菜单
    menuList()
    if (!needGoHome) return
    store.commit('MENU_PATH', '/')
    router.replace({ name: 'Main' }).catch(() => {
      router.replace('/')
    })
  })
}
router.beforeEach((to, form) => {
  // 记录页面访问事件
  // trackEvent('page_view', {
  //   from: form.path,
  //   to: to.path,
  //   title: to.meta.title || to.name
  // })
  if (isIosUniShell && (to.name === 'Main' || to.path === '/')) {
    transitionName.value = ''
  } else if (
    (to.path === '/' && (form.path === '/' || form.path === '/register')) ||
    form.path === '/iframe-view' ||
    to.path.indexOf('/download') > -1 ||
    form.path.indexOf('/h5/') > -1
  ) {
    // 不需要动画
    transitionName.value = ''
  } else {
    if (to.meta.index > form.meta.index) {
      transitionName.value = 'fold-left'
    } else {
      transitionName.value = 'fold-right'
    }
  }
  // 缓存
  if (to.meta.keepAlive && keepAliveNames.value.indexOf(to.name) === -1) {
    keepAliveNames.value.push(to.name)
  }
  // 返回缓存前置页删除缓存
  if (form.meta.keepAlive && form.meta.keepRemove && form.meta.keepRemove === to.name) {
    keepAliveNames.value = keepAliveNames.value.filter((item) => item != form.name)
  }
})
router.afterEach(() => {
  window.scrollTo(0, 0)
})
// if (import.meta.env !== 'development') {
  window.addEventListener('visibilitychange', (e) => {
    if (e.target.visibilityState === 'visible') {
      const currentPath = router.currentRoute.value.path
      if (currentPath === '/pay-result' || currentPath === '/member/pay-result') return
      if (!store.getters.menuList?.length) {
        menuList(getAppStoreName() || storeName.value)
      }
      const currentRouter = localStorage.getItem('currentRouter') || '/'
      router.replace(currentRouter)
    }
  })
  // // 扑捉异常防住更新假死
  window.addEventListener('error', (error) => {
    if (error.message.includes("'text/html' is not a valid JavaScript MIME")) {
      window.location.reload()
    }
  })
// }
</script>

<template>
  <div id="app" style="
      --view-theme: #ff4081;
      --view-theme-16: #ff4081;
      --view-priceColor: #ff4081;
      --view-memberColor: #58330f;
      --view-minorColor: rgba(255, 91, 51, 0.5);
      --view-minorColorT: rgba(255, 91, 51, 0.1);
      --view-bntColor: #ff4081;
      --view-op-ten: rgba(255, 91, 51, 0.1);
      --view-main-start: #ff7a59;
      --view-main-over: #ff4081;
      --view-op-point-four: rgba(255, 91, 51, 0.04);
      --view-op-point-eight: rgba(255, 91, 51, 0.8);
      --view-linear: linear-gradient(90deg, #ff7a59 0%, #ff4081 100%);

      --van-primary-color: #ff4081;
      --van-dialog-confirm-button-text-color: #ff4081;
      --van-button-primary-background: #ff4081;
      --van-button-primary-border-color: #ff4081;
      --van-tabs-bottom-bar-color: #ff4081;

      --page-bg-color: #f7f8fa; /* Warm background */
      --text-main-color: #363636; /* Darker text for readability */
      --text-sub-color: #888888; /* Softer sub-text */
      --card-bg-color: #ffffff;
      --border-radius-lg: 16px;
      --border-radius-md: 12px;
      --box-shadow-base: 0 8px 24px rgba(0, 0, 0, 0.02);
      --box-shadow-sm: 0 2px 12px rgba(0, 0, 0, 0.02);
    " class="font-nunito">
    <router-view v-slot="{ Component }">
      <transition :name="transitionName">
        <keep-alive :include="keepAliveNames">
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
    <!-- 性能监控组件 -->
    <!-- <PerformanceMonitor /> -->
    <DevToolsFloat v-if="DevToolsFloat" />
  </div>
</template>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--page-bg-color);
  font-family: 'Nunito Sans', sans-serif;

  /* 路由页面根节点占满高度，便于内部 overflow-y 滚动（html/body 为 overflow:hidden） */
  >*:first-child {
    flex: 1 1 0;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: visible;
  }

  // push页面时：新页面的进入动画
  .fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: 0.4s;
  }

  // push页面时：老页面的退出动画
  .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: 0.4s;
  }

  // push页面时：新页面的进入动画
  @keyframes fold-left-in {
    0% {
      transform: translate(100%, 0);
      /* visibility: visible; */
    }

    100% {
      transform: translate(0, 0);
    }
  }

  // push页面时：老页面的退出动画
  @keyframes fold-left-out {
    0% {
      transform: translate(0, 0);
    }

    100% {
      transform: translate(-100%, 0);
      /* visibility: hidden; */
    }
  }

  // 后退页面时：即将展示的页面动画
  .fold-right-enter-active {
    animation-name: fold-right-in;
    animation-duration: 0.4s;
  }

  // 后退页面时：后退的页面执行的动画
  .fold-right-leave-active {
    animation-name: fold-right-out;
    animation-duration: 0.4s;
  }

  // 后退页面时：即将展示的页面动画
  @keyframes fold-right-in {
    0% {
      width: 100%;
      transform: translate(-100%, 0);
      /* visibility: visible; */
    }

    100% {
      width: 100%;
      transform: translate(0, 0);
    }
  }

  // 后退页面时：后退的页面执行的动画
  @keyframes fold-right-out {
    0% {
      width: 100%;
      transform: translate(0, 0);
    }

    100% {
      width: 100%;
      transform: translate(100%, 0);
      /* visibility: hidden; */
    }
  }

  img {
    vertical-align: middle;
  }

  .suspension-fixed {
    position: fixed;
    right: 0;
    bottom: 120px;

    &-img {
      width: auto;
      height: auto;
    }
  }
}
</style>
